import React, { useEffect, useState, useRef } from "react"

import "./index.less"
import { Drawer, Input, Select, Button, Popover, Radio, Space } from "antd"
import Loader from "../../../../../components/Loader"

const { TextArea } = Input

export const DrawerSegmentImportableUpload = ({
  steps,
  mode,
  id_segment,
  changeSteps,
  isDownloading,
  getTemplateSegmentCollaborators,
  uploadTemplateSegmentCollaborators,
  importUpload,
}) => {
  const inputRef = useRef(null)
  const uploadCollaborators = async () => {
    inputRef.current.click()
  }
  const downloadTemplate = (event) => {
    event.preventDefault()
    if (!isDownloading) {
      getTemplateSegmentCollaborators(true)
    }
  }
  const fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    if (mode === "edit" && id_segment) {
      fd.append("id_segment", id_segment)
      inputRef.current.value = ""
    }
    uploadTemplateSegmentCollaborators(fd)
  }
  useEffect(() => {
    if (importUpload) {
      changeSteps(steps + 1)
    }
  }, [importUpload])

  return (
    <>
      <Button
        type="link"
        style={{ width: "max-content", padding: 0 }}
        className="drawer-segment-importable-upload-back-button"
        onClick={() => {
          changeSteps(steps - 1)
        }}>
        &lt; Regresar
      </Button>
      <br />
      <span className="drawer-segment-container-label">
        Importación de colaboradores a un segmento
      </span>
      <p className="drawer-segment-importable-upload-paragraph">
        Carga los colaboradores que pertenecerán al segmento que se está
        creando. De ya contar con colaboradores asignados al segmento, los
        colaboradores que importes se añadirán a la población ya asignada.
      </p>
      <div className="drawer-segment-importable-upload-instructions">
        <b>Instrucciones:</b>
        <ol>
          <li>Descarga la plantilla de Excel.</li>
          <li>Llena los campos con la información de los colaboradores.</li>
          <li>Importa el Excel a la plataforma</li>
        </ol>
      </div>
      <br />
      <br />
      <div className="drawer-segment-importable-upload-button-container">
        <Button
          onClick={downloadTemplate}
          disabled={isDownloading}
          loading={isDownloading}
          className="drawer-segment-importable-upload-button">
          Descargar plantilla
        </Button>
        &nbsp; &nbsp;
        <Button
          onClick={uploadCollaborators}
          className="drawer-segment-importable-upload-button">
          Importar colaboradores
        </Button>
        <input
          style={{ display: "none" }}
          type="file"
          id="import"
          onChange={fileSelectedHandler}
          ref={inputRef}
        />
      </div>
    </>
  )
}
export default DrawerSegmentImportableUpload
